import React, { useEffect, useRef } from 'react';

import { Img } from '@randajan/jet-react/dom/img';
import { Button } from '@randajan/jet-react/dom/form';

import { PriceTag } from '../PriceTag/PriceTag';

import "./QrPay.scss";
import { shareOrDownloadQr } from '../../../config/tools/downloadSvgAsPng';


export const QrPay = (props)=>{
    const { monthCount } = props;

    const ref = useRef();
    const url = `/api/pay/qr/months/${monthCount}`;

    const save = async _=>{
        const resp = await fetch(url);
        const pay = await resp.json();
        console.log(pay);
        if (pay) { await shareOrDownloadQr(ref.current, pay.spayd, pay.id); }
    };
    
    return (
        <div className="QrPay">
            <img ref={ref} src={`${url}.svg`}/>
            <div className="ctrls">
                <PriceTag {...props}/>
                {/* <Button onSubmit={save}>Uložit</Button> */}
            </div>
        </div>
    )
}

